import React from 'react'

const HeaderAvatar = ({ fill = '#1B1B1A', style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0_2389_59311)">
        <path
          d="M7.99984 3.93317C8.77317 3.93317 9.39984 4.55984 9.39984 5.33317C9.39984 6.1065 8.77317 6.73317 7.99984 6.73317C7.2265 6.73317 6.59984 6.1065 6.59984 5.33317C6.59984 4.55984 7.2265 3.93317 7.99984 3.93317ZM7.99984 9.93317C9.97984 9.93317 12.0665 10.9065 12.0665 11.3332V12.0665H3.93317V11.3332C3.93317 10.9065 6.01984 9.93317 7.99984 9.93317ZM7.99984 2.6665C6.5265 2.6665 5.33317 3.85984 5.33317 5.33317C5.33317 6.8065 6.5265 7.99984 7.99984 7.99984C9.47317 7.99984 10.6665 6.8065 10.6665 5.33317C10.6665 3.85984 9.47317 2.6665 7.99984 2.6665ZM7.99984 8.6665C6.21984 8.6665 2.6665 9.55984 2.6665 11.3332V13.3332H13.3332V11.3332C13.3332 9.55984 9.77984 8.6665 7.99984 8.6665Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2389_59311">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HeaderAvatar
